<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-04 15:56:36
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 16:57:36
 * @Description: 标的详情
 -->
<template>
  <div class="project-detail-wrapper">
    <!-- <listTopBar :title="baseInfo.name" /> -->
    <div class="content-scroll-wrapper">
      <div class="heard-wrapper">
        <h6>约定年化借款利率</h6>
        <h3 class="rate">{{ baseInfo.annualRate }}<span>%</span></h3>
        <div class="heard-project-box">
          <div class="item">
            <div class="lable">
              项目期限
            </div>
            <p>{{ baseInfo.period }}月</p>
          </div>
          <div class="item">
            <div class="lable">
              项目金额(元)
            </div>
            <p>{{ baseInfo.money }}</p>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <h3>项目明细</h3>
        <div class="list-box">
          <el-row class="detail-row">
            <el-col :span="10" class="label">借款编号 </el-col>
            <el-col :span="14" class="text"> {{ baseInfo.code }}</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">发标日期 </el-col>
            <el-col :span="14" class="text"> {{ baseInfo.createTime }}</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">收益方式 </el-col>
            <el-col :span="14" class="text"> {{ baseInfo.repayWay }}</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">起息日 </el-col>
            <el-col :span="14" class="text"> {{ baseInfo.interestAccrual }}</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">退出机制 </el-col>
            <el-col :span="14" class="text"> 不可提前退出</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">
              项目进度
            </el-col>
            <el-col :span="14" class="text"> {{ baseInfo.progress * 100 }}% </el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">出借笔数 </el-col>
            <el-col :span="14" class="text"> {{ lendNum }}</el-col>
          </el-row>
          <el-row class="detail-row">
            <el-col :span="10" class="label">项目状态 </el-col>
            <el-col :span="14" class="text" v-html="itemStatus"> </el-col>
          </el-row>
        </div>
      </div>
      <div class="content-wrapper content-lender-wrapper">
        <h3>出借记录</h3>
        <div class="table-box">
          <template v-if="lendList.length > 0">
            <div class="table-row" v-for="(item, index) in lendList" :key="index">
              <div class="table-col">{{ item.lender }}</div>
              <div class="table-col">{{ item.money }}元</div>
              <div class="table-col">{{ item.date }}</div>
            </div>
            <router-link
              :to="{
                name: 'm-lend-recoder',
                params: detailParams
              }"
              v-if="totalLength.length > 2"
              ><div class="btn-more">查看更多</div></router-link
            >
          </template>
          <template v-else>
            <div class="table-wrapper no-data">
              暂无数据
            </div>
          </template>
        </div>
      </div>
      <ul class="more-detail-wrapper">
        <li>
          <router-link :to="{ name: 'm-check-record', params: detailParams }">
            <span>审核记录</span>
            <span class="icon-arrow">></span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'm-project-produce', params: detailParams }">
            <span>项目介绍</span>
            <span class="icon-arrow">></span>
          </router-link>
        </li>
        <li>
          <template v-if="isiOS">
            <div>
              <a href="https://jydpro.jinr.com/uploadsFiles/jyd/static/agreement.pdf">
                <span>借款合同</span>
                <span class="icon-arrow">></span>
              </a>
            </div>
          </template>
          <template v-else>
            <div>
              <router-link :to="{ name: 'm-loan-contract' }">
                <span>借款合同</span>
                <span class="icon-arrow">></span>
              </router-link>
            </div>
          </template>
        </li>
        <li>
          <router-link :to="{ name: 'm-repayment-plan', params: detailParams }">
            <span>还款计划</span>
            <span class="icon-arrow">></span>
          </router-link>
        </li>
      </ul>
      <div class="invest-tip">
        — 市场有风险，投资需谨慎 —
      </div>
      <div class="btn-call-wrapper">
        <div class="btn-call" :class="[baseInfo.progress < 1 ? 'active' : '']">
          联系客服立即购买(1010-2015)
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import listTopBar from '@/components/m-list-top';
export default {
  name: 'project-detail',
  // components: {
  //   listTopBar
  // },
  data() {
    return {
      activeIndex: 0,
      lendNum: 0,
      tabList: [
        {
          label: '项目详情'
        },
        {
          label: '出借记录'
        },
        {
          label: '审核记录'
        },
        {
          label: '还款计划'
        }
      ],
      userType: {
        '0': '平台',
        '1': '自然人',
        '2': '法人'
      },
      baseInfo: {
        progress: 0,
        annualRate: 0,
        createTime: 0,
        repayWay: '-',
        interestAccrual: '-'
      },
      lendList: [],
      detailParams: {},
      isiOS: null,
      totalLength: 0
    };
  },
  computed: {
    componentId() {
      return this.componentList[this.activeIndex];
    },
    itemStatus() {
      if (this.baseInfo.progress >= 1) {
        return '已满标';
      } else {
        return '未满标';
      }
    }
  },
  created() {
    if (this.$route.params.flag === '1') {
      this.requestDetail();
      this.requestRecords();
    } else {
      this.requestNo1Detail();
      return;
    }
    this.detailParams = this.$route.params;
    // this.listBarTitle();
  },
  mounted() {
    const u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  },
  methods: {
    async requestDetail() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.pc.detail',
        projectid: this.$route.params.id
        // flag: this.$route.params.flag
      });
      if (res.code === 200) {
        const data = res.data;
        this.baseInfo = {
          name: data.project_name,
          code: data.project_code,
          money: data.moneys,
          remainMoney: data.redius_money,
          currentMoney: parseFloat(data.moneys - data.redius_moneys).toFixed(2),
          progress: parseFloat((data.moneys - data.redius_moneys) / data.moneys).toFixed(2),
          projectDetail: data.desc.projectDetail,
          period: data.period,
          annualRate: data.annual_rate,
          interestAccrual: data.interest_accrual,
          repayWay: data.repay_way,
          createTime: data.c_time,
          costTime: Math.ceil(
            (new Date(data.full_time).getTime() - new Date(data.sell_time).getTime()) / 24 / 3600000
          ) // 满标用时
        };
      }
    },
    async requestRecords() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.invest.user',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        this.lendNum = res.data.list ? res.data.list.length : 0;
        this.totalLength = res.data.list.length;
        this.lendList = res.data.list.slice(0, 2).map(item => {
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
      }
    },
    // 鲸鱼一号
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.baseInfo = {
          name: data.detail.project_name,
          code: data.applyRecord.contract_no,
          money: data.detail.finance_money,
          remainMoney: data.detail.dropTankMoney,
          currentMoney: parseFloat(data.invested_money - data.redius_moneys).toFixed(2),
          progress: parseFloat(data.detail.invested_money / data.detail.finance_money).toFixed(4),
          projectDetail: data.detail.description,
          period: data.detail.project_period,
          annualRate: data.detail.rate_init,
          interestAccrual: data.detail.interest_accrual,
          repayWay: data.detail.repay_way,
          createTime: data.detail.c_time,
          costTime: data.full.fullNum
        };
        this.lendNum = data.investList.length;
        this.userInfo = {
          ...data.debtInfo,
          userName: data.applyRecord.base_info.base_realName,
          sex: data.applyRecord.base_info.base_sex === 1 ? '男' : '女',
          identityId: data.applyRecord.base_info.base_identityid,
          usage: data.applyRecord.base_info.base_usage,
          userType: this.userType[`${data.applyRecord.base_info.user_type}`],
          industry: data.detail.industry,
          income: data.applyRecord.base_info.income,
          // overdueInSixMonth: data.applyRecord.creditReporting.substr(4, 3),
          overdueInSixMonth: data.applyRecord.creditReporting,
          hasOverdue: '未逾期'
        };
        this.componentList[0].props = {
          baseInfo: {
            ...this.baseInfo,
            isGuarantee: data.is_guarantee === 1 ? '是' : '否'
          },
          userInfo: { ...this.userInfo }
        };
        this.componentList[1].props['recordList'] = data.investList.map(item => {
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
        this.componentList[1].props['baseInfo'] = { ...this.baseInfo };
        this.componentList[2].props['checkList'] = data.applyRecord.audit_pic;
        this.componentList[3].props['refundPlan'] = data.returnedList.map(item => {
          return {
            period: item.period,
            interestOfPrincipal: item.need_money,
            principal: item.principal,
            interests: item.interest,
            rest: item.surplus_principal,
            date: item.need_time
          };
        });
      }
    },
    listBarTitle() {
      this.$eventBus.$emit('listBarTitle', this.baseInfo.name);
      console.log('$emit');
    }
  },
  watch: {
    baseInfo() {
      this.listBarTitle();
    }
  }
};
</script>
<style lang="less" scoped>
.project-detail-wrapper {
  position: relative;
  .content-scroll-wrapper {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 99;
  }
  .heard-project-box {
    display: flex;
    justify-content: space-between;
    font-size: 0.28rem;
    padding: 0.32rem 1rem 0;
    .item {
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .lable {
        position: relative;
        color: rgba(255, 255, 255, 0.5);
        &::before {
          content: '';
          display: block;
          position: absolute;
          width: 0.04rem;
          left: -0.1rem;
          top: 0.04rem;
          height: 0.28rem;
          background-color: #fbcf32;
          border-radius: 0.02rem;
        }
      }
      p {
        color: rgba(255, 255, 255, 0.7);
        line-height: 0.4rem;
      }
    }
  }
  .heard-wrapper {
    height: 3.68rem;
    background-image: linear-gradient(180deg, #1865a1 0%, #19518d 100%);
    h6 {
      width: 100%;
      font-size: 0.28rem;
      text-align: center;
      color: #ffffff;
      line-height: 1;
      padding-top: 0.44rem;
      vertical-align: middle;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 1.33rem;
        height: 0.04rem;
        background-image: linear-gradient(90deg, #195f9b 0%, #d8d8d8 100%);
        border-radius: 0.02rem;
        margin-right: 0.2rem;
      }
      &::after {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 1.33rem;
        height: 0.04rem;
        background-image: linear-gradient(-90deg, #195f9b 0%, #d8d8d8 100%);
        border-radius: 0.02rem;
        margin-left: 0.2rem;
      }
    }
    .rate {
      text-align: center;
      font-size: 0.8rem;
      color: #ffffff;
      line-height: 1;
      margin: 0.4rem auto 0.42rem;
      position: relative;
      span {
        font-size: 0.48rem;
      }
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 0;
        position: absolute;
        left: 0;
        bottom: -0.42rem;
        z-index: 1;
        border-style: solid;
        border-width: 0.02rem;
        border-image-source: linear-gradient(
          90deg,
          #185995 0%,
          rgba(255, 255, 255, 0.2) 52%,
          #195b97 100%
        );
        border-image-slice: 1;
        border-top: none;
      }
    }
  }
  .more-detail-wrapper {
    overflow: hidden;
    background: #fff;
    li {
      height: 1rem;
      line-height: 1rem;
      font-size: 0.28rem;
      border-top: solid 0.02rem #e8e8e8;
      padding: 0 0.3rem;
      color: #444444;
      a {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .invest-tip {
    font-size: 0.24rem;
    color: #a2abb4;
    text-align: center;
    line-height: 1rem;
  }
  .btn-call-wrapper {
    height: 1.4rem;
    display: flex;
    align-items: center;
    background: #fff;
  }
  .btn-call {
    width: 7.02rem;
    height: 1.04rem;
    line-height: 1.04rem;
    background-color: #a2bdfe;
    border-radius: 0.16rem;
    font-size: 0.34rem;
    margin: 0 auto;
    color: #ffffff;
    text-align: center;
    &.active {
      background-color: #0d72e2;
    }
  }
  .content-wrapper {
    background: #fff;
    h3 {
      font-size: 0.3rem;
      line-height: 0.95rem;
      // border-bottom: solid 0.02rem #e8e8e8;
      padding: 0 0.3rem;
      box-sizing: border-box;
    }
    .list-box {
      padding: 0 0.3rem;
    }
    .table-box {
      line-height: 1rem;
      font-size: 0.28rem;
      .table-row {
        display: flex;
        justify-content: space-between;
        padding: 0 0.3rem;
        box-sizing: border-box;
        border-top: solid 0.02rem #e8e8e8;
        div:last-child {
          font-size: 0.24rem;
          color: #888888;
        }
      }
      .no-data {
        text-align: center;
      }
    }
    .detail-row {
      display: flex;
      font-size: 0.26rem;
      // padding: 0 0.3rem;
      box-sizing: border-box;
      line-height: 0.5rem;
      .label {
        color: #888888;
      }
      .text {
        color: #333333;
        text-align: right;
      }
    }
    .btn-more {
      height: 0.97rem;
      background: #fff;
      font-size: 0.26rem;
      text-align: center;
      color: #0b71e3;
      border-top: solid 0.02rem #e8e8e8;
    }
  }
  .content-lender-wrapper {
    margin: 0.36rem auto 0.18rem;
  }
}
</style>
